import { render } from "./CalculatorComponent.vue?vue&type=template&id=0ed7b570&scoped=true"
import script from "./CalculatorComponent.vue?vue&type=script&lang=js"
export * from "./CalculatorComponent.vue?vue&type=script&lang=js"

import "./CalculatorComponent.vue?vue&type=style&index=0&id=0ed7b570&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed7b570"]])

export default __exports__